module.exports = __webpack_public_path__ + "img/megaphone-icon.f0ea3bfb.svg";